import template from './mainUIBlock.dot';
const mainUIBlockTemplate = template.default ? template.default : template;
export { mainUIBlockTemplate };
